import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import DepositPaymentRecivedBanner from 'assets/images/DepositPaymentRecivedBanner.png';
import { useHistory } from 'react-router-dom';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';

const DepositPaymentReceivedBannerAgent = (props) => {
  let {
    bannerDetails,
    isAgentDashboard,
    getListInfo,
    profileDetails,
    confirmDeposit,
    setConfirmDeposit,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const onPropertyClick = (propertyId) => {
    if (propertyId) {
      history.push({
        pathname: `dashboard/view-dashboard/${propertyId}`,
        state: {
          propertyIds: true,
          dashboardConfiremDepositBanner: true,
        },
      });
    }
  };

  const onOpen = () => {
    setConfirmDeposit(true);
  };

  const onClose = () => {
    setConfirmDeposit(false);
  };

  const PropertyId = bannerDetails?.propertyId;
  const buyerName = bannerDetails?.buyerFullName;
  const paymentType = bannerDetails?.paymentType;

  const address = bannerDetails?.address;

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    textTransform: 'capitalize',
                    marginTop: matchessm && '-60px',
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: 300,
                  }}
                >
                  {address}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Confirm Deposit Payment Received
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Verify you have received{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 600 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {buyerName}'s
                  </Typography>
                  &nbsp; deposit payment sent via{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {paymentType}{' '}
                  </Typography>
                  .
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    onClick={() => {
                      if (isAgentDashboard) {
                        onPropertyClick(PropertyId);
                      } else {
                        onOpen();
                      }
                    }}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFF',
                      color: '#2184FD',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      '&:hover': {
                        bgcolor: '#FFFFFF',
                        color: '#2184FD',
                      },
                    }}
                  >
                    Confirm Deposit Received
                  </Button>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={DepositPaymentRecivedBanner}
                alt="DepositPaymentRecivedBanner"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      {confirmDeposit && (
        <DetailsPopup
          openDetailsPopup={confirmDeposit}
          handleCloseDetails={() => {
            setConfirmDeposit(false);
          }}
          profileDetails={profileDetails}
          buyerId={bannerDetails?.buyerId}
          isFromBuyerRegister={true}
          getListInfo={getListInfo}
          fromVendorStatus={true}
        />
      )}
    </>
  );
};

export default DepositPaymentReceivedBannerAgent;
